import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import mapboxgl from 'mapbox-gl';
import Navigation from './Navigation';
import AdvancedSearch from './AdvancedSearch';
import { API_ENDPOINTS } from '../config/api';
import './MapPage.css';

// Set Mapbox token from environment variable
const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
if (!MAPBOX_TOKEN) {
  throw new Error(
    'Please add your Mapbox token to .env file (REACT_APP_MAPBOX_TOKEN=your_token_here)'
  );
}
mapboxgl.accessToken = MAPBOX_TOKEN;

const MapPage = () => {
  const [markers, setMarkers] = useState([]);
  const mapContainerRef = useRef(null);

  // Fetch relief data (for markers)
  useEffect(() => {
    axios.get(API_ENDPOINTS.reliefs)
      .then(response => {
        setMarkers(response.data);
        console.log('Reliefs loaded:', response.data);
      })
      .catch(error => {
        console.error('Error fetching reliefs:', error);
      });
  }, []);

  // Initialize Mapbox map once markers are loaded
  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [43.1309, 36.3159], // Adjust center as needed
      zoom: 5
    });

    // Add navigation control (zoom in/out)
    map.addControl(new mapboxgl.NavigationControl(), 'top-right');

    // Add markers from the markers state
    markers.forEach(marker => {
      if (marker.lng && marker.lat) {
        new mapboxgl.Marker()
          .setLngLat([marker.lng, marker.lat])
          .setPopup(new mapboxgl.Popup({ offset: 25 }).setText(marker.title))
          .addTo(map);
      }
    });

    // Cleanup on unmount
    return () => map.remove();
  }, [markers]);

  return (
    <div className="page-container">
      <Navigation />
      <div className="map-page">
        <div className="search-container">
          <AdvancedSearch />
        </div>
        <div className="map-container" ref={mapContainerRef}></div>
      </div>
    </div>
  );
};

export default MapPage; 